import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_PARTNER_ACCOUNT_LIMITS_QUERY = gql`
  query partnerAccountLimits($input: BankAccountIdentifier!) {
    partnerAccountLimits(input: $input) {
      achLimits {
        dailyDebit
        dailyCredit
        monthlyDebit
        monthlyCredit
      }
      achTotalsDaily {
        debits
        credits
      }
      achTotalsMonthly {
        debits
        credits
      }
      wireLimits {
        daily
        monthly
      }
      wireTotalsDaily
      wireTotalsMonthly
      currency
      wireOutgoingFee
    }
  }
`;

export const GET_CHECK_DEPOSIT_LIMITS_QUERY = gql`
  query partnerAccountCheckDepositLimits($input: BankAccountIdentifier!) {
    partnerAccountLimits(input: $input) {
      checkDepositLimits {
        daily
        monthly
      }
      checkDepositTotalsDaily
      checkDepositTotalsMonthly
      currency
    }
  }
`;

export const GET_TRANSACTION_LIMITS_QUERY = gql`
  query unitTransactionLimits($input: BankAccountIdentifier!, $businessEntityUuid: UUID!) {
    partnerAccountLimits(input: $input) {
      achLimits {
        dailyDebit
        dailyCredit
        monthlyDebit
        monthlyCredit
      }
      cardLimits {
        dailyCardTransaction
        dailyDeposit
        dailyPurchase
        dailyWithdrawal
      }
      checkDepositLimits {
        daily
        monthly
      }
      checkPaymentLimits {
        dailySent
        monthlySent
      }
      wireLimits {
        daily
        monthly
      }
    }
    instantFundingAccounts(businessEntityUuid: $businessEntityUuid) {
      transactionMetrics {
        dailyTransferLimit {
          amount
        }
        monthlyTransferLimit {
          amount
        }
        perTransferLimit {
          amount
        }
        minimumTransferLimit {
          amount
        }
      }
    }
  }
`;
